import Experiment from '@mc/experiments-react'

import { usePromoGiftEnabled } from '@mc/promos'
import { usePromotion } from '@mc/promo-utils'

import { GiftsLink } from './GiftsLink'

const ADD_GIFTS_TO_NAVIGATION_FLAG = 'pen-4703_v3'

type GiftsInNavExperimentProps = {
  viewPlansLink: React.ReactNode
}

/**
 * Experiment showing additional 'Gifts' item either to the left (variant 1), or right (variant 2) of the 'View Plans'
 * Desktop navigation menu.
 * @see https://app.growthbook.io/features/pen-4703_v1
 * @see https://app.growthbook.io/features/pen-4703_v2
 * @see https://app.growthbook.io/features/pen-4703_v3 (Promo only + gift enabled experiment)
 *
 */
export const GiftsInNavExperiment = ({
  viewPlansLink,
}: GiftsInNavExperimentProps) => {
  const { giftEnabled } = usePromoGiftEnabled()
  const { isPromotionOn } = usePromotion()

  if (!giftEnabled || !isPromotionOn) return viewPlansLink

  return (
    <Experiment
      name={ADD_GIFTS_TO_NAVIGATION_FLAG}
      default={() => viewPlansLink}
      variant_1={() => (
        <>
          <GiftsLink />
          {viewPlansLink}
        </>
      )}
      variant_2={() => (
        <>
          {viewPlansLink}
          <GiftsLink />
        </>
      )}
    />
  )
}
